import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { actions as amddActions } from 'Data/ReduxViewModels/AssignedValuesTests';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PageSection } from '../../../Layout';
import { WorksheetImagesAndRemarksSection, WorksheetRootComponent } from '../../Core';
import ids from '../../QestIds';
import AsAssignedValuesResultsSection from './Sections/ResultsSection';
import AsValueAssignmentSection from './Sections/ValueAssignmentSection';
const qestIds = [ids.assignedMaximumDryDensity.AS_1289_5_4_2.rev2007];

let AsAssignedMaximumDryDensityWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(amddActions.init());
  }, [dispatch]);

  return (
    <>
      <PageSection heading="Value Assignment">
        <AsValueAssignmentSection />
      </PageSection>
      <PageSection heading="Assigned Values">
        <AsAssignedValuesResultsSection />
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AsAssignedMaximumDryDensityWorksheet = withInjectedProps(AsAssignedMaximumDryDensityWorksheet);
AsAssignedMaximumDryDensityWorksheet.qestIds = qestIds;

export default AsAssignedMaximumDryDensityWorksheet;
export { AsAssignedMaximumDryDensityWorksheet };
